import { useStation } from '@app/core/stations/hooks/useStation';
import { SocialPlatform, socialPlatforms } from '@app/modules/social-export/domain/platforms';
import { isSocialExportEnabledForStation } from '@app/modules/social-export/hooks/useSocialExportEnabledForStation';
import { webApi } from '@mi-front/api-clients';

/**
 * Returns platforms that are connected for the station, enabled for social export,
 * and have no existing uploads for the fragment. Used to show "Publicar en" dropdown options.
 */
export function useAvailableExportPlatforms(
  stationId: string | undefined,
  uploadsByPlatform: Map<string, webApi.FragmentSocialUploadItemDto[]> | undefined,
): SocialPlatform[] {
  const station = useStation(stationId ?? '');
  const connectionsQuery = webApi.useGetSocialConnectionsConnectionsForStation(stationId ?? '', {
    query: { enabled: !!stationId },
  });

  const results = connectionsQuery.data?.results ?? [];
  const platforms = socialPlatforms.all();

  return platforms.filter((platform) => {
    if (!isSocialExportEnabledForStation(station, platform)) return false;
    const connected =
      results.find((r) => r.platform.toUpperCase() === platform.id.toUpperCase())?.connected ??
      false;
    if (!connected) return false;
    const uploads = uploadsByPlatform?.get(platform.id) ?? [];
    return uploads.length === 0;
  });
}
